import firebase from 'firebase/compat/app';
import STORE_CONSTANTS, {
  LEGACY_BONUS_APPS_DOC,
  LEGACY_BONUS_APPS_VERSION,
} from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export { LEGACY_BONUS_APPS_DOC, LEGACY_BONUS_APPS_VERSION };

const legacyBonusAppConverter = {
  toFirestore(app: V3.LegacyBonusApp): firebase.firestore.DocumentData {
    return withoutNulls({ ...app });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<V3.LegacyBonusApp>,
    options: firebase.firestore.SnapshotOptions,
  ): V3.LegacyBonusApp {
    const data = {
      ...snapshot.data(options),
    };

    const app: V3.LegacyBonusApp = {
      ...data,
      appViewersAccess: data.appViewersAccess
        ? data.appViewersAccess
        : {
            isPublic: false,
            userIds: [],
            groupIds: [],
          },
      adminUserIds: data.adminUserIds ? data.adminUserIds : [],
    };

    return app;
  },
};

const getLegacyBonusAppsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(LEGACY_BONUS_APPS_DOC)
    .collection(LEGACY_BONUS_APPS_VERSION)
    .withConverter(legacyBonusAppConverter);
};

export default getLegacyBonusAppsRef;
